module.exports = __webpack_public_path__ + "static/media/web.0db0f1ea.svg";